import { createContext, useContext, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { COPY } from "./copy";

const LangContext = createContext({ lang: "en", t: COPY.en, to: (p) => p });

export const LanguageProvider = ({ children }) => {
  const { pathname } = useLocation();
  const lang = pathname === "/es" || pathname.startsWith("/es/") ? "es" : "en";

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => {
    const to = (p) => {
      if (lang !== "es") return p;
      return p === "/" ? "/es" : `/es${p}`;
    };
    return { lang, t: COPY[lang], to };
  }, [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
